import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state: any) => state.get('organizationSelector') || initialState;

export const selectUpdating = createSelector(selectState, (state) => state.get('updating'));
